
import { defineComponent, onMounted } from 'vue';
import Page from '@/components/Page.vue';
import scripts from '@/assets/service.js';

export default defineComponent({
  components: {
    Page,
  },
  setup () {
    onMounted(() => {
      scripts.serviceScript();
    });
  },
});
